import { Box } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const PageSwapper = styled.div`
   width: 100%;
   min-height: 100vh;
   box-sizing: border-box;
   text-align: center;
  //  background-color:#f2f2f2;
   background: linear-gradient(139.73deg, rgb(229, 253, 255) 0%, rgb(243, 239, 255) 100%);
   padding: 73px 0 20px;

   input {
    background: #fff;
    border-radius: 8px;
    &:focus:not(:disabled) {
      box-shadow: 0px 0px 0px 1px #9a84c8, 0px 0px 0px 1px rgb(118 69 217 / 60%);
    }
  }
  // 不换行
  .whiteSpaceN {
    white-space:nowrap;
  }
  .wordBreak {
    word-break: break-all;
  }
`
export const Page = styled.div`
margin: 0 auto;
max-width:1600px;
gap:10px;
text-align: start;
cursor: pointer;
// white-space:nowrap;
display: flex;
justify-content: center;
align-items: flex-start;
@media (max-width: 768px) {
  flex-direction: column;
}
`
export const ButtonSwapper = styled.div`
  button {
    width: 100%;
  }
`
export const PageLeft = styled.div`
  width: 60%;
  padding: 1rem ;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`
export const PageRight = styled.div`
  width: 40%;
  flex: 1;
  margin-left:1rem;
  height: 100%;
  padding-top: 2rem;
  @media (max-width: 768px) {
    margin-left:0;
    margin-top:3rem;
    width: 100%;
  }
`
export const LogoSwapper = styled.div`
  height: 32rem;
  margin-top: 1rem;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  overflow: scroll;
  white-space: nowrap;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  &::-webkit-scrollbar {
    display: none;
  }
`